import React from 'react';
import { Target } from 'lucide-react';

interface StepFocusIndicatorProps {
  stepTitle?: string;
  stepId?: string;
  onClear?: () => void;
}

const StepFocusIndicator: React.FC<StepFocusIndicatorProps> = ({ stepTitle, stepId, onClear }) => {
  if (!stepId) return null;

  return (
    <div className="flex items-center gap-2 p-2 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-lg mb-2">
      <Target className="w-4 h-4 text-yellow-600 dark:text-yellow-400" />
      <span className="text-sm text-yellow-800 dark:text-yellow-200 flex-1">
        Focused on: {stepTitle || `Step ${stepId.substring(0, 8)}...`}
      </span>
      {onClear && (
        <button
          onClick={onClear}
          className="text-xs text-yellow-600 dark:text-yellow-400 hover:underline"
        >
          Clear
        </button>
      )}
    </div>
  );
};

export default StepFocusIndicator;

